import { render, staticRenderFns } from "./VenueCampaignsMenu.vue?vue&type=template&id=f4bd028a&"
import script from "./VenueCampaignsMenu.vue?vue&type=script&lang=js&"
export * from "./VenueCampaignsMenu.vue?vue&type=script&lang=js&"
import style0 from "./VenueCampaignsMenu.vue?vue&type=style&index=0&id=f4bd028a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports